export enum QuoteStatus {
  RECEIVED_QUOTE = "received_quote",
  NEGOTIATED_QUOTE = "negotiated_quote",
  WAITING_ON_RESPONSE = "waiting_on_response", // when the venue hasn't responded yet
  NOT_AVAILABLE = "not_available", // when the venue is not available
  OUT_OF_BUDGET = "out_of_budget", // when the venue is out of budget
}

export enum EventStatus {
  CONFIRM_EVENT_DETAILS = "confirm_event_details", // on the stage where they should check that the event details are correct (will not be able to edit after)
  DEPOSIT = "deposit", // needs to pay deposit
  CONFIRMED_EVENT_DETAILS = "confirmed_event_details", // they have confirmed the event details and paid, but waiting for options to appear
  NARROW_OPTIONS = "narrow_options", // options appeared, they should choose which ones they want
  WAIT_FOR_PROPOSALS = "wait_for_proposals", // chose the ones they wanted, now they are waiting for proposals to come in
  NEGOTIATE = "negotiate", // shortlisted venues, now reviewing and negotiating contracts
  QUOTE_DASHBOARD = "quote_dashboard", // the proposals came in, and they must choose which ones to negotiate
  WAIT_FOR_VENUE_CONFIRMATION = "wait_for_venue_confirmation", // they chose one and they are waiting for confirmation
  VENUE_RECEIPT = "venue_receipt", // they are done booking,
  CANCELLED = "cancelled",
}

export enum PaymentLabel {
  DEPOSIT = "deposit", //for the $500 deposits
  HOTEL = "hotel",
  RESTAURANT = "restaurant",
  FLIGHT = "flight",
  ACTIVITY = "activity",
  COWORKING = "coworking",
  TRANSPORTATION = "transportation",
  SOURCING_FEE = "sourcing_fee",
  OTHER = "other",
  EVENT_SPACE = "event_space",
  REFUNDABLE = "refundable",
  SUBSCRIPTION = "subscription",
  ENTERPRISE_DEPOSIT = "enterprise_deposit", // org-scoped one-time deposit unlocking enterprise RFP sends
  TEST = "test",
}

export enum CustomerDecisionStatus {
  SHORTLISTED = "shortlisted",
  DECLINED = "declined",
  PENDING = "pending",
  REMOVED = "removed",
}

export enum InternalEventStatus {
  ACTIVE = "active", // when the status is active
  DONE_SOURCING = "done_sourcing", // when sourcing is completed
  BOOKED_OFF_PLATFORM = "booked_off_platform", // when the event is booked off platform
  CANCELED = "canceled", // when the status is canceled
  TEST = "test",
  GHOSTED = "ghosted", // when the client doesn't respond after 5 bumps
  INTERNAL = "internal", // when the event is internal test and we want to keep it around for testing
  UNQUALIFIED = "unqualified", // when the event isn't a fit (e.g. wrong ICP or spam submission)
  PAUSED = "paused", // when the event is temporarily on hold
}

export enum StripePaymentStatus {
  SUCCEEDED = "succeeded",
  PENDING = "pending",
  SAVE_FOR_LATER = "save_for_later",
  SCHEDULED = "scheduled",
  ARCHIVED = "archived",
  WIRE = "wire",
}

export enum BrexPaymentStatus {
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  DECLINED = "DECLINED",
  CLEARED = "CLEARED",
  CANCELED = "CANCELED",
  REFUNDED = "REFUNDED",
  PROCESSING = "PROCESSING",
  REFUNDING = "REFUNDING",
  SCHEDULED = "SCHEDULED",
}

export enum WireCategory {
  Nowadays = "Nowadays",
  Rent = "Rent",
  Insurance = "Insurance",
  Dividend = "Dividend",
  Stripe = "Stripe",
  Rewards = "Rewards",
  Brex = "Brex",
  Transfer = "Transfer",
  Rippling = "Rippling",
  Investor = "Investor",
  Customer = "Customer",
  Vendor = "Vendor",
  Partnership = "Partnership",
  CustomerVendor = "Customer/Vendor",
}

export enum SlackNotificationType {
  WEBSITE = "WEBSITE",
  PAYMENTS = "PAYMENTS",
  ADMIN = "ADMIN",
  EXPLORE = "EXPLORE",
  EMAIL = "EMAIL",
  BREX = "BREX",
  QUOTES = "QUOTES",
  TEST = "TEST",
  EVENT = "EVENT",
  FLAGGED_EMAIL = "FLAGGED_EMAIL",
  INTERVAL = "INTERVAL",
  NORTHSTAR = "NORTHSTAR",
  JOSH = "JOSH",
  SIGNUP = "SIGNUP",
  FETCH = "FETCH",
  CAREER = "CAREER",
  GOOGLE = "GOOGLE",
  HYATT = "HYATT",
  QUO_ALERTS = "QUO_ALERTS",
}

export enum VenueType {
  HOTEL = "hotel",
  RESTAURANT = "restaurant",
  AIRBNB = "airbnb",
  AIRBNB_EXPERIENCES = "airbnb_experiences",
  AIRBNB_SERVICES = "airbnb_services",
  VRBO = "vrbo",
  VILLA = "villa",
  HIPCAMP = "hipcamp",
  GLAMPINGHUB = "glampinghub",
  COWORKING = "coworking",
  OTHER = "other",
  ACTIVITY = "activity",
  EVENT_SPACE = "event_space",
  CATERING = "catering",
  VENDOR = "vendor",
  RANCH = "ranch",
  YURT = "yurt",
  VACATION_RENTAL = "vacation_rental",
  BAR = "bar",
  NIGHTCLUB = "nightclub",
  RESORT = "resort",
}

export enum PhoneCallStatus {
  PENDING = "pending",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "cancelled",
}

export enum PageType {
  NARROW_OPTIONS = "narrow-options",
  QUOTE_DASHBOARD = "quote-dashboard",
  BOOKINGS = "bookings",
  MAP_OPTIONS = "map-options",
}

export enum BookingStatus {
  RESERVED,
  PENDING,
  CANCELLED,
  COMPLETED,
}
